/**
 * Account API Service
 * Handles all account-related API calls
 */

import { apiGet, apiPut } from '../manager';
import { API_ENDPOINTS } from '../config';

const USE_MOCK_DATA = false;

/**
 * Get account details (university + admin)
 * @param {Object} options
 * @returns {Promise<Object>} { university_details, admin_details }
 */
export const getAccountDetails = async (options = {}) => {
  // const useMock = options.useMock !== undefined ? options.useMock : USE_MOCK_DATA;

  // if (useMock) {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve({
  //         success: true,
  //         data: {
  //           university_details: {
  //             name: 'Demo University',
  //             code: 'DU',
  //             contact_email: 'info@university.edu',
  //             phone: '+1 234 567 8900',
  //             website: 'https://www.university.edu',
  //             location: {
  //               country: 'United States',
  //               state: 'California',
  //               city: 'Los Angeles',
  //               zip: '90001',
  //               address: '123 University Avenue',
  //             },
  //           },
  //           admin_details: {
  //             first_name: 'Admin',
  //             last_name: 'User',
  //             email: 'admin@university.edu',
  //             phone_number: '+1 234 567 8900',
  //             designation: 'Administrator',
  //           },
  //         },
  //       });
  //     }, options.mockDelay || 500);
  //   });
  // }

  const response = await fetch('https://prod-api.botguru.ai/api/v1/accounts/university/account/', {
    method: 'GET',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });
  const data = await response.json();
  return { success: response.ok, data };
};

/**
 * Update account details
 * @param {Object} accountData - { university_details, admin_details }
 * @param {Object} options
 * @returns {Promise<Object>}
 */
export const updateAccountDetails = async (accountData, options = {}) => {
  const useMock = options.useMock !== undefined ? options.useMock : USE_MOCK_DATA;

  if (useMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ success: true, data: accountData });
      }, options.mockDelay || 500);
    });
  }

  const response = await fetch('https://prod-api.botguru.ai/api/v1/accounts/university/account/update/', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(accountData),
  });
  const data = await response.json();
  return { success: response.ok, data };
};